type DD = [number, number];
type DMS = [[number, number, number, number], [number, number, number, number]];

export function dd2dms(xy: DD): DMS {
	return <DMS> xy.map(v => {
		const arr = [1, 0, 0, 1];
		const splDeg = v.toString().split('.');
		arr[0] = Math.abs(Number(splDeg[0]));

		if (splDeg.length === 2) {
			const valMin = Math.abs(Number.parseFloat(`.${ splDeg[1] }`) * 60);
			const splMin = valMin.toString().split('.');
			arr[1] = Math.abs(Number(splMin[0]));
			arr[2] = Number((splMin.length === 2 ? Math.abs(Number.parseFloat(`.${ splMin[1] }`) * 60) : 0).toFixed(4));
		}

		arr[3] = v >= 0 ? 1 : -1;
		return arr;
	});
}

export function dms2dd(arr: DMS): DD {
	return <DD> arr.map(([deg, min, sec, dir]) => Number((dir * (deg + (min / 60) + (sec / 3600))).toFixed(6)));
}
